// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    creaseList: [],
    selectedCrease: null,
    message: null,
    status: false,
    error: ''
};

const slice = createSlice({
    name: 'crease',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
        },
        setCreases(state, action) {
            state.creaseList = action.payload;
        },
        setSelectedCrease(state, action) {
            state.selectedCrease = action.payload;
        },
        setCrease(state, action) {
            const data = action.payload;
            const rowIndex = state.creaseList.findIndex((item) => item.id === data.id);
            if (rowIndex) {
                state.creaseList[rowIndex] = data;
            }
        }
    }
});

// Reducer
export default slice.reducer;
export const { setSelectedCrease } = slice.actions;
// ----------------------------------------------------------------------

export function getCreases() {
    return async () => {
        try {
            const response = await axios.post('/crease/list');
            if (response.data.status) {
                dispatch(slice.actions.setCreases(response.data.data));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error.message));
        }
    };
}
export function getCrease(id) {
    return async () => {
        try {
            const response = await axios.post('/crease/details', { id });
            if (response.data.status) {
                dispatch(slice.actions.setCrease(response.data.data));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            console.log(error);
        }
    };
}
export function saveCrease(data) {
    return async function () {
        const response = await axios.post('crease/save', data);
        return response;
    };
}

export function updateCrease(data) {
    return async function () {
        const response = await axios.post('crease/update', data);
        return response;
    };
}

export function deleteCrease(data) {
    return async function () {
        const response = await axios.post('crease/delete', data);
        return response;
    };
}
